import { theme } from "../theme";

// ── Metrika v horní řadě přehledu ─────────────────────────────────────────────
// Nízká karta: popis vlevo, číslo vpravo. Na širokém monitoru byla svislá
// varianta zbytečně vysoká — jedno číslo v kartě široké přes 700 px.
export default function MetricCard({ icon, title, value, suffix, note, tone = "neutral" }) {
  const barvaPoznamky = tone === "ok" ? theme.ok : tone === "bad" ? theme.bad : theme.mut;
  const barvaIkony = tone === "bad" ? theme.bad : tone === "ok" ? theme.ok : theme.blue;
  const pozadiIkony = tone === "bad" ? theme.badSoft : tone === "ok" ? theme.okSoft : theme.blueSoft;

  return (
    <div style={{
      flex: 1, minWidth: 240,
      background: theme.bg, border: `1.5px solid ${theme.line}`,
      borderRadius: theme.rCard, padding: "16px 20px", boxShadow: theme.shadowSm,
      display: "flex", alignItems: "center", gap: 14,
    }}>
      <span style={{
        width: 36, height: 36, borderRadius: theme.rTile, flexShrink: 0,
        background: pozadiIkony, color: barvaIkony,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>{icon}</span>

      <div style={{ minWidth: 0, flex: 1 }}>
        <p style={{ fontSize: 14, fontWeight: 700, color: theme.ink }}>{title}</p>
        {note && (
          <p style={{ fontSize: 12.5, fontWeight: 600, color: barvaPoznamky, marginTop: 2 }}>{note}</p>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "baseline", gap: 6, flexShrink: 0 }}>
        <span style={{ fontSize: 30, fontWeight: 800, color: theme.ink, lineHeight: 1, fontVariantNumeric: theme.tnum }}>
          {value}
        </span>
        {suffix && (
          <span style={{ fontSize: 18, fontWeight: 700, color: theme.mut, lineHeight: 1, fontVariantNumeric: theme.tnum }}>
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
}
